export default {
  // 通知表示最大数
  DISP_NOTIFICATION_NUM_MAX: 9,
  // 通知表示最小数
  DISP_NOTIFICATION_NUM_MIN: 0,
};
